import { SegmentedControl, Stack, StackProps, Text } from '@mantine/core';
import React, { useState } from 'react';

import { DeviceDetailsType } from '@portals/api/organizations';

import { DeviceTelemetries } from './index';
import { Events } from '../events';

interface DeviceLogProps {
  device: DeviceDetailsType;
}

type LogTab = 'telemetries' | 'events';

export function DeviceLog({ device }: DeviceLogProps) {
  const [activeTab, setActiveTab] = useState<LogTab>('telemetries');

  const showBothTabs =
    device.tabs.telemetries === true && device.tabs.events === true;

  if (!showBothTabs) {
    if (device.tabs.telemetries === true) {
      return (
        <DeviceLogContainer>
          <Text fz="lg" fw={500}>
            Telemetries
          </Text>
          <DeviceTelemetries device={device} />
        </DeviceLogContainer>
      );
    }

    if (device.tabs.events === true) {
      return (
        <DeviceLogContainer>
          <Text fz="lg" fw={500}>
            Events
          </Text>
          <Events device={device} />
        </DeviceLogContainer>
      );
    }
  }

  return (
    <DeviceLogContainer>
      <SegmentedControl
        value={activeTab}
        onChange={(value: LogTab) => setActiveTab(value)}
        data={[
          { label: 'Telemetries', value: 'telemetries' },
          { label: 'Events', value: 'events' },
        ]}
      />

      {activeTab === 'events' ? (
        <Events device={device} />
      ) : (
        <DeviceTelemetries device={device} />
      )}
    </DeviceLogContainer>
  );
}

function DeviceLogContainer({ children, ...stackProps }: StackProps) {
  return (
    <Stack h="100%" spacing="xl" mt="xl" {...stackProps}>
      {children}
    </Stack>
  );
}
